import AddressButton from '../../../components/AddressButton'
import Form from '../../../components/form/Form'
import useFormFields from '../../../hooks/useFormFields'

const AddressForm = () => {
  const storeForm = 'addressForm'
  const { addressFields } = useFormFields()
  return (
    <div className="addressForm">
      <div className="addressForm-container">
        <div className="addressForm-form">
          <div className="addressForm-title">Cargá los datos del domicilio</div>
          <Form fields={addressFields} storeForm={storeForm} inputsPosition="floating" />
        </div>
        <div className="addressForm-action">
          <AddressButton storeForm={storeForm} />
        </div>
      </div>
    </div>
  )
}

export default AddressForm
